import { css } from 'linaria';
import { styled } from 'linaria/react';

export const yandexSplitContainer = css`
  display: flex;
  padding: var(--space-150) !important;
  align-items: flex-start;
  align-self: stretch;
  border-radius: var(--rounding-l);
  background: var(--background-secondary);
  border: 0;
  justify-content: flex-start;

  & > *:first-child {
    gap: var(--space-100);
  }
`;

export const additionalMarginTop = css`
  margin-top: var(--space-200);
`;

export const additionalMarginBottom = css`
  margin-bottom: var(--space-100);
`;

export const smallPadding = css`
  padding: var(--space-100) !important;
`;

export const textContainer = css`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: var(--space-100);
  margin: auto 0;
`;

export const withPrice = css`
  gap: 0;
`;

export const yandexSplitLogo = css`
  margin: auto 0;
`;

export const SkeletonContainer = styled.div<{
  isSet?: boolean;
}>`
  display: flex;
  align-items: center;
  height: 60px;
  padding: var(--space-150);
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
  gap: var(--space-100);
  margin-top: ${(props) => (props.isSet ? 'var(--space-200)' : '0')};
`;

export const skeletonBase = css`
  background-color: var(--control-secondary);
  border-radius: var(--rounding-m);
  padding: 0 !important;
`;

export const skeletonInnerContainer = css`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
  gap: var(--space-100);
`;

export const firstSkeleton = css`
  height: 20px !important;
  width: 20px !important;
  margin-bottom: auto;
`;

export const secondSkeleton = css`
  width: 94px !important;
  height: 12px !important;
  margin-right: auto;
`;

export const threeSkeleton = css`
  width: 166px !important;
  height: 10px !important;
  margin-right: auto;
`;
